import * as React from 'react';
import Swal from 'sweetalert2';
import { jaxa } from '../../App';
import { columns } from '../employees/gridData';
import EmployeeInfo from '../employees/EmployeeInfo';
import { CustomizedDataGrid } from '../../components';
import CreateEmployee from '../employees/CreateEmployee';
import { RefreshRounded as RefreshIcon } from '@mui/icons-material';
import { Box, Typography, Button, Backdrop, CircularProgress, IconButton } from '@mui/material';

export default function Admin() {

    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(true);

    const [empId, setEmpId] = React.useState(null);

    const [employees, setEmployees] = React.useState([]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const clearEmpId = () => setEmpId(null);

    const getEmpData = async() => {
        setLoading(true);
        await jaxa.get('/get-admins').then((res) => setEmployees(res.data)).catch((e) => {
            Swal.fire({ title: 'Failed to get admin employees' });
            console.log(`Error: ${e}`);
        });
        setLoading(false);
    };

    React.useEffect(() => {
        getEmpData();
    }, []);

    const loader = React.useMemo(() => (
        <Backdrop open>
            <CircularProgress/>
        </Backdrop>
    ), []);

    return (

        <Box sx={{ width: '100%', height: '100vh' }}>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', mb: 2 }}>
                <Typography component="h2" variant="h6" sx={{ mb: 2 }}>Admins & Super Admins</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <IconButton onClick={getEmpData} disabled={loading}>
                        <RefreshIcon/>
                    </IconButton>
                    <Button disabled={loading} variant="outlined" onClick={handleOpen} sx={{ ml: 2 }}>CREATE</Button>
                </Box>
            </Box>
            <CustomizedDataGrid columns={columns} rows={employees} onClick={e => setEmpId(e)}/>
            {open ? <CreateEmployee admin open={open} handleClose={handleClose}/> : null}
            {empId ? <EmployeeInfo admin empId={empId} open={Boolean(empId)} handleClose={clearEmpId}/> : null}
            {loading ? loader : null}
        </Box>

    );

};